import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import {
  generateRevenueChartPayload,
  generateTransactionChartPayload,
} from "./libs/generateRevenueChartPayload";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const chartSetting = {
  xAxis: [{ dataKey: "created_at", scaleType: "band" }],
  yAxis: [{ dataKey: "total_amount_spent" }],
  series: [{ dataKey: "total_amount_spent", color: "#467CEB" }],
};

const RevenueChart = ({ data, height }) => {
  const { selectedFacility } = useSelector((state) => state.stationList);
  const { selectedDate } = useSelector((state) => state.datePicker);
  const valueFormatter = (value) =>
    `${localStorage.getItem("currency") ?? " "}${value?.toFixed(2)}`;
  const [revenueDetails, setRevenueDetails] = useState([
    {
      created_at: 0,
      total_amount_spent: 0,
      revenue: 0,
      electricity: 0,
      profit: 0,
      company_profit: 0,
    },
  ]);
  chartSetting.height = height || 220;

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (data?.view_facility_revenue_aggregate?.nodes) {
      const { is_fleet } = selectedFacility;
      const { start, end } = selectedDate;
      if (!is_fleet) {

        (async () => {
          const details = await generateRevenueChartPayload(
            data?.view_facility_revenue_aggregate?.nodes,
            start?.toISOString(),
            end?.toISOString()
          );
          setRevenueDetails(
            details?.length > 0
              ? details
              : [
                  {
                    created_at: 0,
                    total_amount_spent: 0,
                    revenue: 0,
                    electricity: 0,
                    profit: 0,
                    company_profit: 0,
                  },
                ]
          );
          chartSetting.xAxis = [{ dataKey: "created_at", scaleType: "band" }];
          chartSetting.yAxis = [{ dataKey: "total_amount_spent" }];
          chartSetting.series = [
            {
              dataKey: "total_amount_spent",
              valueFormatter,
              color: "#467CEB",
              label: "Revenue",
            },
          ];
        })();
        
      } else {

        (async () => {
          const details = await generateTransactionChartPayload(
            data?.view_facility_revenue_aggregate?.nodes,
            start?.toISOString(),
            end?.toISOString(),
            true,
            selectedFacility
          );
          setRevenueDetails(
            details?.length > 0
              ? details
              : [
                  {
                    created_at: 0,
                    total_amount_spent: 0,
                    revenue: 0,
                    electricity: 0,
                    profit: 0,
                    company_profit: 0,
                  },
                ]
          );
          chartSetting.xAxis = [{ dataKey: "created_at", scaleType: "band" }];
          chartSetting.series = [
            {
              dataKey: "revenue",
              valueFormatter,
              label: "Revenue",
              color: "#467CEB",
            },
            {
              dataKey: "electricity",
              valueFormatter,
              label: "Electricity",
              color: "green",
            },
            { dataKey: "profit", valueFormatter, label: "Terra Profit" },
            {
              dataKey: "company_profit",
              valueFormatter,
              label: "Station Profit",
            },
          ];
        })();
      }
      setLoading(false);
    }
  }, [data, selectedFacility, selectedDate]);

  return (
    <Box
      bgcolor={"white"}
      p={3}
      borderRadius={"16px"}
      padding={"24px 24px 8px"}
    >
      <Typography variant="subtitle" fontWeight="600">
        {t("revenue")}
        {loading ? (
          <span style={{ color: "#467CEB" }}> {t("loading")}...</span>
        ) : (
          ""
        )}
      </Typography>
      {revenueDetails?.length > 0 && (
        <Grid container flexDirection="column">
          <Grid item display="flex">
            <Grid
              item
              display="flex"
              alignItems="center"
              sx={{ transform: "rotate(-90deg)" }}
              fontSize="12px"
              fontWeight="600"
              textTransform="uppercase"
            >
              {t("amount")}
            </Grid>
            <BarChart
              dataset={revenueDetails}
              layout="vertical"
              {...chartSetting}
            />
          </Grid>
          <Grid
            item
            display="flex"
            justifyContent="center"
            fontSize="12px"
            fontWeight="600"
            textTransform="uppercase"
          >
            {t("date")}
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default RevenueChart;
